import { PrismicTextAlignmentField } from '@monofront/types';
import { isFilled } from '@prismicio/client';

export const usePrismicTextAlignmentStyle = (
  textAlignmentField: PrismicTextAlignmentField | undefined,
) => {
  const alignment = (() => {
    if (!isFilled.select(textAlignmentField)) {
      return '';
    }

    switch (textAlignmentField ?? 'default') {
      case 'left':
        return 'tw-text-left';
      case 'center':
        return 'tw-text-center';
      default:
        return '';
    }
  })();

  return alignment;
};
